(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('TimeseriesDataSearch', TimeseriesDataSearch);

    TimeseriesDataSearch.$inject = ['$resource'];

    function TimeseriesDataSearch($resource) {
        var resourceUrl =  'api/_search/timeseries-data/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
